import {
  FiBell,
  FiBriefcase,
  FiCalendar,
  FiCreditCard,
  FiDollarSign,
  FiFileText,
  FiLink,
  FiMapPin,
  FiShield,
  FiTag,
} from "react-icons/fi";

export const ADMIN_TABS = [
  { id: "home", labelKey: "admin.nav.home", labelFallback: "Home" },
  { id: "bookings", labelKey: "admin.nav.bookings", labelFallback: "Bookings" },
  { id: "events", labelKey: "admin.nav.events", labelFallback: "Events" },
  { id: "inventory", labelKey: "admin.nav.inventory", labelFallback: "Inventory" },
  { id: "loc-partners", labelKey: "admin.nav.locationsPartners", labelFallback: "Loc & Partners" },
  { id: "payments", labelKey: "admin.nav.money", labelFallback: "Money" },
  { id: "customers", labelKey: "admin.nav.customers", labelFallback: "Customers" },
  { id: "analytics", labelKey: "admin.nav.analytics", labelFallback: "Analytics" },
  { id: "settings", labelKey: "admin.nav.settings", labelFallback: "Settings" },
  { id: "logs", labelKey: "admin.nav.logs", labelFallback: "Logs" },
];

export const AUDIT_LABELS = {
  security: "Security",
  ops: "Ops",
  critical: "Critical",
  info: "Info",
  warning: "Warning",
  neutral: "Neutral",
};

export const BOOKING_STATUS_OPTIONS = [
  "all",
  "Pending",
  "Confirmed",
  "InUse",
  "Completed",
  "Cancelled",
];

export const BOOKING_STATUS_TONE = {
  Pending: "warning",
  Confirmed: "info",
  InUse: "success",
  Completed: "ink",
  Cancelled: "critical",
};

export const PAYMENT_STATUS_OPTIONS = [
  "all",
  "Succeeded",
  "Processing",
  "Failed",
  "Pending",
  "Refunded",
  "PartiallyRefunded",
];

export const PAYMENT_TYPE_OPTIONS = [
  { value: "all", label: "All types" },
  { value: "payment", label: "Payments" },
  { value: "refund", label: "Refunds" },
];

export const BOOKING_ISSUE_OPTIONS = [
  { value: "none", label: "No issues" },
  { value: "late_check_in", label: "Late check-in" },
  { value: "damage", label: "Damage reported" },
  { value: "no_check_in", label: "No check-in" },
  { value: "other", label: "Other" },
];

export const REFUND_REASONS = [
  { value: "cancellation", label: "Cancellation" },
  { value: "service-issue", label: "Service issue" },
  { value: "dispute", label: "Dispute" },
  { value: "goodwill", label: "Goodwill" },
  { value: "other", label: "Other" },
];

export const REFUND_STATUS_TONE = {
  Succeeded: "success",
  Processing: "warning",
  Failed: "critical",
};

export const PAYMENT_STATUS_TONE = {
  Pending: "warning",
  Processing: "info",
  Succeeded: "success",
  Failed: "critical",
  PartiallyRefunded: "warning",
  Refunded: "neutral",
};

export const MONEY_METRICS = [
  { id: "revenue", labelKey: "admin.money.metric.revenue", labelFallback: "Revenue" },
  { id: "profit", labelKey: "admin.money.metric.profit", labelFallback: "Profit" },
  {
    id: "expenses",
    labelKey: "admin.money.metric.expenses",
    labelFallback: "Expenses (refunds)",
  },
];

export const ANALYTICS_INTERVALS = [
  { id: "day", labelFallback: "Day" },
  { id: "week", labelFallback: "Week" },
  { id: "month", labelFallback: "Month" },
];

export const ANALYTICS_RANGE_PRESETS = [
  { id: "today", label: "Today" },
  { id: "last7Days", label: "Last 7 days" },
  { id: "last30Days", label: "Last 30 days" },
  { id: "thisMonth", label: "This month" },
  { id: "custom", label: "Custom" },
];

export const ANALYTICS_SUBTABS = [
  { id: "revenue", label: "Revenue" },
  { id: "utilization", label: "Utilization" },
  { id: "operations", label: "Operations" },
  { id: "attendance", label: "Attendance" },
];

export const SETTINGS_NAV_GROUPS = [
  {
    id: "core",
    label: "Core",
    sections: [
      { id: "booking", label: "Booking", icon: FiCalendar },
      { id: "pricing", label: "Pricing", icon: FiTag },
      { id: "branding", label: "Branding & Page Text", icon: FiBriefcase },
    ],
  },
  {
    id: "operations",
    label: "Operations",
    sections: [
      {
        id: "locations",
        label: "Locations & Partners",
        icon: FiMapPin,
        potential: true,
      },
      {
        id: "payments",
        label: "Payments & Invoicing",
        icon: FiCreditCard,
        danger: true,
        potential: true,
      },
      { id: "notifications", label: "Notifications", icon: FiBell },
    ],
  },
  {
    id: "security",
    label: "Security & System",
    sections: [
      {
        id: "security",
        label: "Users & Security",
        icon: FiShield,
        danger: true,
        potential: true,
      },
      { id: "integrations", label: "Integrations", icon: FiLink, potential: true },
      { id: "audit", label: "Audit & System", icon: FiFileText, danger: true },
    ],
  },
];

export const SETTINGS_SECTION_INTROS = {
  booking: {
    eyebrow: "Booking rules"
  },
  pricing: {
    eyebrow: "Pricing & offers"
  },
  branding: {
    eyebrow: "Branding & page text"
  },
  locations: {
    eyebrow: "Locations & partners"
  },
  payments: {
    eyebrow: "Payments & invoicing"
  },
  notifications: {
    eyebrow: "Notifications"
  },
  security: {
    eyebrow: "Users & security"
  },
  integrations: {
    eyebrow: "Integrations"
  },
  audit: {
    eyebrow: "Audit & system"
  },
};

export const SETTINGS_SEARCH_INDEX = [
  {
    id: "season-dates",
    sectionId: "audit",
    title: "Season dates",
    keywords: ["season", "dates", "booking", "window", "start", "end"],
  },
  {
    id: "booking-window",
    sectionId: "booking",
    title: "Booking window",
    keywords: ["booking", "window", "notice", "advance", "expire"],
  },
  {
    id: "capacity-handling",
    sectionId: "booking",
    title: "Capacity handling",
    keywords: ["overbooking", "capacity", "inventory", "hold"],
  },
  {
    id: "cancellation-policy",
    sectionId: "booking",
    title: "Cancellation policy",
    keywords: ["cancel", "cancellation", "no-show", "fee"],
  },
  {
    id: "late-checkin-policy",
    sectionId: "booking",
    title: "Late check-in policy",
    keywords: ["late", "check-in", "overdue", "fee", "grace"],
  },
  {
    id: "qr-rules",
    sectionId: "booking",
    title: "QR pickup & return",
    keywords: ["qr", "scan", "pickup", "return"],
  },
  {
    id: "base-pricing",
    sectionId: "pricing",
    title: "Base pricing",
    keywords: ["price", "pricing", "equipment", "rate"],
  },
  {
    id: "discounts",
    sectionId: "pricing",
    title: "Discounts & promo codes",
    keywords: ["discount", "promo", "code", "voucher"],
  },
  {
    id: "deposits",
    sectionId: "pricing",
    title: "Deposits",
    keywords: ["deposit", "damage", "refund"],
  },
  {
    id: "locations-settings",
    sectionId: "locations",
    title: "Locations",
    keywords: ["location", "hours", "pickup", "address"],
  },
  {
    id: "partner-profiles",
    sectionId: "locations",
    title: "Partner profiles",
    keywords: ["partner", "payout", "iban", "legal"],
  },
  {
    id: "commission-model",
    sectionId: "locations",
    title: "Commission model",
    keywords: ["commission", "fee"],
  },
  {
    id: "equipment-assignment",
    sectionId: "locations",
    title: "Equipment assignment",
    keywords: ["equipment", "allocation", "stock"],
  },
  {
    id: "partner-access",
    sectionId: "locations",
    title: "Partner access settings",
    keywords: ["partner", "access", "permissions"],
  },
  {
    id: "payment-provider",
    sectionId: "payments",
    title: "Payment provider",
    keywords: ["payment", "provider", "stripe", "revolut", "keys", "webhook", "live", "test"],
  },
  {
    id: "refund-rules",
    sectionId: "payments",
    title: "Refund rules",
    keywords: ["refund", "refunds", "manual"],
  },
  {
    id: "payouts",
    sectionId: "payments",
    title: "Payouts",
    keywords: ["payout", "schedule", "commission"],
  },
  {
    id: "invoices",
    sectionId: "payments",
    title: "Invoices & receipts",
    keywords: ["invoice", "receipt", "pdf"],
  },
  {
    id: "roles-permissions",
    sectionId: "security",
    title: "Roles & permissions",
    keywords: ["roles", "permissions", "owner", "staff"],
  },
  {
    id: "login-security",
    sectionId: "security",
    title: "Login security",
    keywords: ["2fa", "session", "security"],
  },
  {
    id: "admin-keys",
    sectionId: "security",
    title: "Admin keys",
    keywords: ["admin key", "rotate", "key"],
  },
  {
    id: "calendar-export",
    sectionId: "integrations",
    title: "Calendar export",
    keywords: ["calendar", "ical"],
  },
  {
    id: "accounting-export",
    sectionId: "integrations",
    title: "Accounting export",
    keywords: ["accounting", "csv", "accountant"],
  },
  {
    id: "maps",
    sectionId: "integrations",
    title: "Maps",
    keywords: ["maps", "google"],
  },
  {
    id: "webhooks",
    sectionId: "integrations",
    title: "Webhooks",
    keywords: ["webhook", "event"],
  },
  {
    id: "audit-log",
    sectionId: "audit",
    title: "Audit log settings",
    keywords: ["audit", "log", "retention"],
  },
  {
    id: "system-health",
    sectionId: "audit",
    title: "System health",
    keywords: ["health", "uptime", "status"],
  },
  {
    id: "backups-exports",
    sectionId: "audit",
    title: "Backups & exports",
    keywords: ["backup", "export", "data"],
  },
  {
    id: "danger-zone",
    sectionId: "audit",
    title: "Danger zone",
    keywords: ["danger", "delete", "disconnect", "reset"],
  },
];

export const LOG_CATEGORY_DEFS = [
  {
    id: "payment",
    label: "Payments",
    icon: FiDollarSign,
    keywords: ["payment", "refund", "payout", "charge", "invoice", "stripe", "revolut"],
  },
  {
    id: "booking",
    label: "Bookings",
    icon: FiCalendar,
    keywords: ["booking", "checked", "check-in", "check-out", "pickup", "return"],
  },
  {
    id: "settings",
    label: "Settings",
    icon: FiBriefcase,
    keywords: ["setting", "policy", "pricing", "vat", "template", "rule"],
  },
  {
    id: "partner",
    label: "Partners",
    icon: FiMapPin,
    keywords: ["partner", "location", "commission"],
  },
  {
    id: "inventory",
    label: "Equipment",
    icon: FiTag,
    keywords: ["equipment", "inventory", "stock", "maintenance", "lost"],
  },
  {
    id: "security",
    label: "Security",
    icon: FiShield,
    keywords: ["login", "auth", "token", "pin", "security", "key", "permission"],
  },
  {
    id: "system",
    label: "System",
    icon: FiLink,
    keywords: ["system", "webhook", "automation", "job", "reminder", "background"],
  },
];

export const LOG_ACTOR_TYPES = [
  { id: "all", label: "All actors" },
  { id: "owner", label: "Owner" },
  { id: "staff", label: "Staff" },
  { id: "partner", label: "Partner" },
  { id: "system", label: "System" },
];

export const LOG_SEVERITY_OPTIONS = [
  { id: "info", label: "Info" },
  { id: "warning", label: "Warning" },
  { id: "critical", label: "Critical" },
];

export const DEFAULT_REFUND_FORM = {
  isFull: true,
  isHalf: false,
  amount: "",
  reason: "cancellation",
  note: "",
};

export const DEFAULT_LOCATION_FORM = {
  name: "",
  address: "",
  city: "",
  postalCode: "",
  country: "Austria",
  timezoneId: "Europe/Vienna",
  operatingHours: "",
  blockedDates: [],
  bookingLeadTimeHours: "0",
  latitude: "",
  longitude: "",
  supportsDayBookings: true,
  supportsNightBookings: true,
  isActive: true,
};
